import type { ReactNode } from "react";
import { ShoppingCart } from "lucide-react";
import type { CatalogProduct } from "@/lib/catalog";
import { affiliateUrl } from "@/lib/catalog";
import { Button, type ButtonProps } from "@/components/ui/button";

type BuyLinkProps = {
  product: CatalogProduct;
  children?: ReactNode;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
  className?: string;
  showIcon?: boolean;
};

export function BuyLink({
  product,
  children = "Comprar na Ybera",
  size = "lg",
  variant = "ybera",
  className,
  showIcon = true,
}: BuyLinkProps) {
  const href = affiliateUrl(product);
  if (!href) {
    return (
      <Button size={size} variant="secondary" disabled className={className}>
        Link oficial em atualização
      </Button>
    );
  }

  return (
    <Button asChild size={size} variant={variant} className={className}>
      <a href={href} rel="sponsored noopener noreferrer">
        {showIcon ? <ShoppingCart aria-hidden /> : null}
        {children}
      </a>
    </Button>
  );
}
